var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightGrayCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0556 17.013C14.2209 17.013 16.7868 14.4471 16.7868 11.2818C16.7868 8.11657 14.2209 5.55063 11.0556 5.55063C7.89038 5.55063 5.32444 8.11657 5.32444 11.2818C5.32444 14.4471 7.89038 17.013 11.0556 17.013ZM11.0556 18.0011C14.7666 18.0011 17.7749 14.9928 17.7749 11.2818C17.7749 7.57084 14.7666 4.5625 11.0556 4.5625C7.34464 4.5625 4.3363 7.57084 4.3363 11.2818C4.3363 14.9928 7.34464 18.0011 11.0556 18.0011Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.987325 1.80598H14.4149V6.40397C14.7748 6.652 15.106 6.93881 15.4023 7.25837V0.818359H0V14.0524H5.81735C5.65164 13.7388 5.51323 13.4086 5.40529 13.0648H0.987325V1.80598Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6568 12.0691L10.6568 6.3418L11.6591 6.3418L11.6591 12.0691L10.6568 12.0691Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0991 11.2059L14.4169 12.8648L13.9753 13.748L10.6575 12.0891L11.0991 11.2059Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14781 2.86364L2.14781 4.47048e-08L3.17053 0L3.17053 2.86364L2.14781 2.86364Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26133 2.86364L7.26133 4.47048e-08L8.28406 0L8.28406 2.86364L7.26133 2.86364Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 2.86364L12.375 4.47048e-08L13.3977 0L13.3977 2.86364L12.375 2.86364Z",
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGrayCalendar);
export default __webpack_public_path__ + "static/media/lightGrayCalendar.7013eae65becccc33b8d7e14e64f152d.svg";
export { ForwardRef as ReactComponent };